import React, { useEffect, useRef, useState } from 'react';
import { QuizConfig } from './config';

interface ProgressProps {
    timeInSeconds: number;
    stop: boolean;
    objectId: number;
    onTimesUp: () => void;
}

const ProgressBar = ({objectId, timeInSeconds, stop, onTimesUp}: ProgressProps) => {

    const [pClasses, setPClasses] = useState("quiz-progress");
    const timeoutRef = useRef<null | NodeJS.Timeout>(null);

    const initDelay = QuizConfig.ProgressBarInitialDelayInMS;
    const transitionDurationInMS = (timeInSeconds * 1000) - initDelay;

    const cleanUp = () => {
        console.log("cleanup progressbar");
        if(timeoutRef.current) {
            console.log("clearing progressbar timeout");
            clearTimeout(timeoutRef.current);
        }

        window.removeEventListener("message", messageHandler);
    };

    const messageHandler = (event: MessageEvent) => {
        console.log("message", event);
        if(event.data === 'QUIZCLEANUP' && event.origin === window.location.origin) {            
            cleanUp();
        }
    };

    useEffect(() => {
        console.log("progressbar mount");
        
        window.addEventListener("message", messageHandler);
        
        if(objectId > 0) {
            const timer = setTimeout(() => {
                setPClasses("biz-primary quiz-progress start");
                clearTimeout(timer);
            }, initDelay);
        }      
        
        timeoutRef.current = setTimeout(() => {
            onTimesUp();
        }, timeInSeconds * 1000);

        return () => {
            console.log("progressbar unmount");
            cleanUp();
        }
    }, [objectId]);

    useEffect(() => {
        if(stop) {
            console.log("stop progressbar");
            setPClasses("biz-primary quiz-progress start paused");
        }
    }, [stop])

    return (
        <div className='quiz-progress-container'>
            <div className='quiz-progress-bar biz-secondary'>            
                <div className={pClasses} style={{animationDuration: `${transitionDurationInMS}ms`}}></div>
            </div>
        </div>
    );
}

export default ProgressBar;